/**
 * Component: Free Gift script
 * ------------------------------------------------------------------------------
 * A snippet to display the cart value required to receive a free gift
 *
 * @namespace upsellPromo
 */
import * as cart from '@shopify/theme-cart';
import axios from 'axios';

/**
 * DOM selectors.
 */
const selectors = {
  message: '[js-upsell-promo="message"]',
};

/**
 * Create a new gift with purchase object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    message: [...document.querySelectorAll(selectors.message)],
  };

  /**
   * Initialise component.
   */
  function init() {
    setEventBusListeners();
  }

  /**
   * Set listeners to update on every cart change.
   */
  function setEventBusListeners() {
    Frame.EventBus.listen('AjaxCart:updated', (response) => renderUpsellBanner(response));
  }

  /**
   * Update notification template using new values.
   * @param {Number} total - Current cart total.
   */
  function renderUpsellBanner() {
    const upsell = {
      messages: theme.UpsellPromo.messages,
      promo: theme.UpsellPromo.promo_properties,
    };

    axios.get('/cart.js')
      .then(response => {
        const cart = response.data;
        // now have access to Shopify cart object
        var isBundle = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].properties && cart.items[i].properties['Bundle'] === upsell.promo) {
            isBundle = true;
            break;
          }
        }

        if (cart.total_discount > 1 && isBundle) {
          nodeSelectors.message.forEach((element) => {
            element.innerHTML = upsell.messages.initial_ideal;
            element.classList.add('promo-ideal');
          });
        } else {
          /**
           * Message shown when the customer has not spent enough to
           * earn the first gift
           */
          nodeSelectors.message.forEach((element) => {
            element.innerHTML = upsell.messages.initial_partial;
            element.classList.remove('promo-ideal');
          });
        }
      })
      .catch(error => {
        console.error("Error fetching cart data:", error);
      });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init
  });
};
